import { SanctionMatchRecord } from 'app/entities/monitoring/actual/sanction-matches.model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';

import { Sanction } from 'app/shared/models/sanction.model';
import { EntityType } from 'app/shared/models/entity-id-details.model';

// @todo: This file is still to be updated with Monitoring REST calls.

/**
 * Service for Monitoring Information Details card.
 */
@Injectable()
export class SanctionService {

    constructor(private requestService: ObservableRequestService) { }

    getSanctionInfoMatchDesc(entityId: number, entityType: EntityType): Observable<any> {
        const sanctionMatchDescUri = ConstantsService.MONITORING_SANCTION_MATCH_SERVICES + '/' + entityId;
        return this.requestService.getRequest(sanctionMatchDescUri).map(response => {
            return response.arrResult || { suggestionList: [] };
        });
    };

    getSanctionMatchDetail(entityId: number, sanctionEntityId: string): Observable<any> {
        const uri = ConstantsService.MONITORING_SANCTION_MATCH_SERVICES + '/' + entityId + '/match/' + encodeURIComponent(sanctionEntityId);
        return this.requestService.getRequest(uri).map(response => response.arrResult);
    };

    updateSanctionInfoDescription(elaborationTextSaveData: Sanction, entityType: string): Observable<any> {
        const generalInfoSavePath = (entityType.toLocaleLowerCase() === 'person') ?
                                    ConstantsService.ENTITY_PERSON_GENERAL_INFO_SERVICES :
                                    ConstantsService.ENTITY_ORG_GENERAL_INFO_SERVICES;
        return this.requestService.putRequest(generalInfoSavePath,
            JSON.stringify(elaborationTextSaveData),
            this.requestService.getJSONContentType());
    };

    updateSanctionMatchDescription(elaborationTextSaveData: Sanction, entityType: string): Observable<any> {
        const generalInfoSavePath = (entityType.toLocaleLowerCase() === 'person') ?
                                    ConstantsService.ENTITY_PERSON_GENERAL_INFO_SERVICES :
                                    ConstantsService.ENTITY_ORG_GENERAL_INFO_SERVICES;
        return this.requestService.putRequest(generalInfoSavePath,
            JSON.stringify(elaborationTextSaveData),
            this.requestService.getJSONContentType());
    };

    markSanctionResolve(sanctionMatchRecord: SanctionMatchRecord): Observable<any> {
        const sanctionResolveURL = ConstantsService.RESOLVE_SANCTION;
        return this.requestService.putRequest(sanctionResolveURL,
            JSON.stringify(sanctionMatchRecord),
            this.requestService.getJSONContentType());
    };
}


// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/sanction/sanction.service.ts